"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Spin = function Spin(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles["default"], {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: "spinCircle",
    cx: "50",
    cy: "50",
    r: "45"
  }));
};

var _default = Spin;
exports["default"] = _default;